import { Button } from '@/components/ui/Button';

interface LoadMoreButtonProps {
    label: string;
    disabled?: boolean;
    onClick: () => void;
}

export function LoadMoreButton({
    label,
    disabled,
    onClick,
}: LoadMoreButtonProps) {
    return (
        <Button
            type="button"
            variant="ghost"
            disabled={disabled}
            onClick={onClick}
            className="w-full justify-start h-9 rounded-lg px-2 text-sm text-grey-300 hover:text-grey-200 hover:bg-grey-600 font-normal"
        >
            <span className="truncate">{label}</span>
        </Button>
    );
}
